import ShareControls, {} from  '@/components/elements/shareControls/shareControls';
import  React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const ShareControlsPortal = () => {


    const [shareEnabled, setShareEnabled] = useState<boolean>(false)
    const [shareLink, setShareLink] = useState<string>('');
    const [externalShareType, setExternalShareType] = useState<string>('')
    const [targetContainer, setTargetContainer] = useState<HTMLDivElement>();

    useEffect(() => {
        getTargetContainer();
    },[])

    function getTargetContainer(){
        let tc:HTMLDivElement = document.getElementById('react-share-control-portal') as HTMLDivElement
        
        if(tc) {
            setTargetContainer(tc)
            setShareEnabled(tc.getAttribute('data-shareenabled') === 'True');
            setShareLink(tc.getAttribute('data-sharelink'))
            setExternalShareType(tc.getAttribute('data-externalsharetype'));
        }
    }
    
    if (!targetContainer) {
        //if there is nowhere for the portal, do not display
        return null;
    } else {
        //data stored at the react-acknowledgement-container
        // Extract data attributes
              

        return ReactDOM.createPortal(
            <ShareControls 
                shareEnabled={shareEnabled}
                shareLink={shareLink}
                externalShareType={externalShareType}
            />,
            targetContainer
        );
    }
}

export default ShareControlsPortal
